<template>
  <ul class="nav-sidebar__top-level-items">
    <fragment v-if="items.length">
      <sidebar-nav-menu-top-level-item
        v-for="item in items"
        :key="item.key"
        :item-key="item.key"
        :href="item.href"
        :target="item.target"
        :title="item.title"
        :icon="item.icon"
        :children="item.children"
        :active="activeItem == item.key"
        :is-external-link="Boolean(item.isExternalLink)"
        :active-item-key="activeItem"
        @click="item.onClick?.()"
        @click-second-level-item="(child, e) => $emit('click-second-level-item', child, e)"
      >
        <template #icon>
          <slot name="icon" v-bind="{ item }"></slot>
        </template>
        <template #title>
          <slot name="title" v-bind="{ item }"></slot>
        </template>
        <template #topLevelItemIconAppend>
          <slot name="navSidebarTopLevelItemIconAppend" v-bind="{ item }"></slot>
        </template>
        <template #navSidebarSecondLevelItem="{ item: secondLevelItem }">
          <slot name="navSidebarSecondLevelItem" v-bind="{ item: secondLevelItem }"></slot>
        </template>
        <template #navSidebarThirdLevelItem="{ item: thirdLevelItem }">
          <slot name="navSidebarThirdLevelItem" v-bind="{ item: thirdLevelItem }"></slot>
        </template>
      </sidebar-nav-menu-top-level-item>
    </fragment>
  </ul>
</template>

<script>
  export default {
    name: 'SidebarNavMenu',

    components: {
      SidebarNavMenuTopLevelItem: () => import('./SidebarNavMenuTopLevelItem'),
    },

    props: {
      items: { type: Array, default: () => [] },
      activeItem: {
        type: String,
        default: null,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .nav-sidebar__top-level-items {
    list-style-type: none;
    margin-bottom: 0;
    padding-left: 0;
  }
</style>
